import { render, staticRenderFns } from "./updateDialog.vue?vue&type=template&id=e2b71476&scoped=true&"
import script from "./updateDialog.vue?vue&type=script&lang=js&"
export * from "./updateDialog.vue?vue&type=script&lang=js&"
import style0 from "./updateDialog.vue?vue&type=style&index=0&id=e2b71476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b71476",
  null
  
)

export default component.exports